module.exports = __webpack_public_path__ + "img/观音寺乡.81aead3d.png";